import { useEffect, useState } from "react";
import axios from "axios";

export default function LandingList({ onEdit }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        // ✅ LISTA: retorna ARRAY [{id,title,slug}, ...]
        const res = await axios.get("https://ngs.adv.br/backend/get_landing.php");
        setList(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Erro ao carregar landings", err);
        setList([]);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  if (loading) return <div style={{ marginBottom: 20 }}>Carregando...</div>;

  return (
    <div style={{ marginBottom: 40 }}>
      <h2>Landings Criadas</h2>

      {list.length === 0 && (
        <div style={{ padding: 10, color: "#555" }}>Nenhuma landing cadastrada.</div>
      )}

      {list.map((l) => (
        <div
          key={l.id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #ddd",
            padding: "10px 0",
            gap: 10
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <strong>{l.title}</strong>
            <small style={{ color: "#666" }}>slug: {l.slug}</small>
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            <a
              href={`https://ngs.adv.br/lp/${l.slug}`}
              target="_blank"
              rel="noreferrer"
              style={{
                padding: "8px 10px",
                borderRadius: 8,
                border: "1px solid #ddd",
                textDecoration: "none",
                color: "#111"
              }}
            >
              Ver
            </a>

            <button
              type="button"
              onClick={() => {
                console.log("CLICOU EDITAR:", l.slug);
                onEdit(l.slug); // ✅ envia slug
              }}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: "none",
                cursor: "pointer",
                background: "#111",
                color: "#fff",
                fontWeight: 700
              }}
            >
              Editar
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
